"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emptyList = emptyList;
function emptyList() {
    return {
        pagination: {
            totalItems: 0,
            totalPages: 0,
            pageSize: 0,
            currentPage: 1,
            sort: [
                {
                    field: '',
                    direction: 'desc',
                },
            ],
        },
        items: [],
    };
}
